import { api } from '../services/api';
import { useApi } from '../hooks/useApi';
import Loading from '../components/common/Loading';
import ErrorMessage from '../components/common/ErrorMessage';
import './PalmaresPage.css';

function formatDate(dateStr) {
  if (!dateStr) return '';
  return new Date(dateStr).toLocaleDateString('fr-FR', {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
  });
}

export default function PalmaresPage() {
  const { data: entries, loading, error, refetch } = useApi(api.getPalmares);

  return (
    <div className="palmares-page">
      <section className="palmares-page__header section section--dark">
        <div className="container">
          <h1 className="palmares-page__title staatliches-regular">
            Palmarès
          </h1>
          <p className="palmares-page__subtitle chiron-goround-tc-body">
            Les vainqueurs des tournois Invitational Champions Collective.
          </p>
        </div>
      </section>

      <section className="palmares-page__content section">
        <div className="container">
          {loading && <Loading text="Chargement du palmarès..." />}
          {error && <ErrorMessage message={error} onRetry={refetch} />}
          {!loading && !error && (!entries || entries.length === 0) && (
            <div className="palmares-page__empty chiron-goround-tc-body">
              <p>Aucune entrée dans le palmarès pour le moment.</p>
              <p>Les vainqueurs des Invitationals apparaîtront ici.</p>
            </div>
          )}
          {!loading && !error && entries && entries.length > 0 && (
            <div className="palmares-list">
              {entries.map((entry) => (
                <div key={entry.id} className="palmares-entry card">
                  <div className="palmares-entry__header">
                    <h2 className="palmares-entry__tournament staatliches-regular">
                      {entry.tournamentName}
                    </h2>
                    <span className="palmares-entry__date chiron-goround-tc-light">
                      {formatDate(entry.date)}
                    </span>
                  </div>
                  <div className="palmares-entry__player">
                    <span className="palmares-entry__winner-label chiron-goround-tc-light">Vainqueur</span>
                    <h3 className="palmares-entry__winner-name staatliches-regular">
                      {entry.player}
                    </h3>
                  </div>
                  {entry.teamWithSprites && entry.teamWithSprites.length > 0 && (
                    <div className="palmares-entry__team">
                      {entry.teamWithSprites.map((pokemon, idx) => (
                        <div key={idx} className="palmares-entry__pokemon">
                          {pokemon.spriteUrl ? (
                            <img
                              src={pokemon.spriteUrl}
                              alt={pokemon.id}
                              className="palmares-entry__sprite"
                              loading="lazy"
                            />
                          ) : (
                            <div className="palmares-entry__sprite-placeholder">?</div>
                          )}
                          <span className="palmares-entry__pokemon-name chiron-goround-tc-light">
                            {pokemon.id}
                          </span>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
